import { Helmet } from 'react-helmet-async'
import styled from 'styled-components'
import Comp from '../components/Co'
import PageWrapper from './PageWrapper'

function Projects() {
  return (
    <PageWrapper>
      <Helmet>
        <title>Projects</title>
      </Helmet>
      <h1> My Projects</h1>
      <CoWrapper>
        <Comp />
      </CoWrapper>
    </PageWrapper>
  )
}

const CoWrapper = styled.div`
  display: grid;
  width: 100%;
  gap: 2rem 2rem;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media (max-width: 1800px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export default Projects
